"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunityItem = CommunityItem;
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardActionArea2 = _interopRequireDefault(require("@mui/material/CardActionArea"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Avatar2 = _interopRequireDefault(require("@mui/material/Avatar"));
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _community = _interopRequireDefault(require("../assets/images/community.svg"));
var _communityJoinDialog = require("./community-join-dialog");
var _icons = require("./icons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ItemContent({
  Button: CustomButton,
  currentUser,
  geogroup,
  joined,
  openJoinDialog,
  handleTryToJoinAsGuest
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const Button = CustomButton || _Button2.default;
  return /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      height: '100%',
      '&&': {
        padding: 2
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0
  }, geogroup ? /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    src: geogroup.photo || _community.default,
    sx: {
      height: 60,
      width: 60
    }
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 60,
    variant: "circular",
    width: 60
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    width: "calc(100% - 76px)"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600,
    sx: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    variant: "body1",
    width: "100%"
  }, geogroup ? geogroup.title : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  })), geogroup && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, geogroup.type === 'company' ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 0.5
  }, /*#__PURE__*/_react.default.createElement(_icons.CompanyIcon, {
    color: "primary",
    sx: {
      height: 16,
      width: 16
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "primary",
    lineHeight: 1,
    variant: "caption"
  }, t('commons.communities.joined_communities.company'))) : geogroup.type !== 'city' && !geogroup.openMembership && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 0.5
  }, /*#__PURE__*/_react.default.createElement(_icons.LockOutlinedIcon, {
    color: "primary",
    sx: {
      height: 16,
      width: 16
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "primary",
    lineHeight: 1,
    variant: "caption"
  }, t('commons.communities.joined_communities.private')))), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, geogroup ? t('commons.communities.members', {
    count: geogroup.nbMembers
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  }))))), !joined && geogroup && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    disableElevation: true,
    color: "primary",
    disabled: currentUser === undefined,
    onClick: () => currentUser !== null ? openJoinDialog?.(true) : handleTryToJoinAsGuest?.(),
    size: "small",
    variant: "contained"
  }, t('commons.communities.actions.join', {
    context: geogroup.type === 'company' ? 'company' : ''
  }))));
}
function CommunityItem({
  Button,
  Dialog,
  currentUser,
  geogroup,
  joined,
  handleClick,
  handleCommunityJoined,
  handleTryToJoinAsGuest
}) {
  const [joinDialogOpen, openJoinDialog] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Card2.default, {
    sx: {
      borderRadius: '10px',
      width: {
        xs: '100%',
        sm: 'calc((100% - 24px) / 2)',
        lg: 'calc((100% - 48px) / 3)'
      }
    },
    variant: "outlined"
  }, geogroup && joined && handleClick ? /*#__PURE__*/_react.default.createElement(_CardActionArea2.default, {
    onClick: () => handleClick(geogroup),
    sx: {
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(ItemContent, {
    joined: true,
    Button: Button,
    currentUser: currentUser,
    geogroup: geogroup
  })) : /*#__PURE__*/_react.default.createElement(ItemContent, {
    Button: Button,
    currentUser: currentUser,
    geogroup: geogroup,
    handleTryToJoinAsGuest: handleTryToJoinAsGuest,
    joined: joined,
    openJoinDialog: openJoinDialog
  })), /*#__PURE__*/_react.default.createElement(_communityJoinDialog.CommunityJoinDialog, {
    Button: Button,
    currentUser: currentUser,
    Dialog: Dialog,
    geogroup: geogroup,
    onClose: async (geogroup, data) => {
      if (geogroup) {
        if (data?.waiting) {
          enqueueSnackbar(t('commons.communities.join_dialog.asked'));
        } else {
          handleCommunityJoined?.(geogroup.id);
        }
      } else openJoinDialog(false);
    },
    open: joinDialogOpen
  }));
}